import { render, staticRenderFns } from "./SysBmApplicationForm.vue?vue&type=template&id=bf0bbf0c&scoped=true&"
import script from "./SysBmApplicationForm.vue?vue&type=script&lang=js&"
export * from "./SysBmApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./SysBmApplicationForm.vue?vue&type=style&index=0&id=bf0bbf0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0bbf0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf0bbf0c')) {
      api.createRecord('bf0bbf0c', component.options)
    } else {
      api.reload('bf0bbf0c', component.options)
    }
    module.hot.accept("./SysBmApplicationForm.vue?vue&type=template&id=bf0bbf0c&scoped=true&", function () {
      api.rerender('bf0bbf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysBmApplicationForm.vue"
export default component.exports